export enum Features {
  // please keep this one at all times, is used for testing
  // and should stay even if no feature toggle is used at the moment
  FEATURE_TOGGLE_TEST = 'FEATURE_TOGGLE_TEST',
  ALWAYS_SHOW_ENVIRONMENT_INDICATOR = 'ALWAYS_SHOW_ENVIRONMENT_INDICATOR',
  // normal Features go here:
  GRAPHQL_GDPR_SELF_ASSESSMENT = 'GRAPHQL_GDPR_SELF_ASSESSMENT',
  MUNICH_DEMO = 'MUNICH_DEMO',
  DSBOSS_SCENARIOS_TABLE_PACE = 'DSBOSS_SCENARIOS_TABLE_PACE',
  STOP_NETWORK_IMPORTS = 'STOP_NETWORK_IMPORTS',
  FLEET_TRACING_EXPERIMENTAL = 'FLEET_TRACING_EXPERIMENTAL',
  STOP_NETWORK_TILE_FETCH = 'STOP_NETWORK_TILE_FETCH',
  LAKE_NONA_FLAT_TIRE_SIMULATION = 'LAKE_NONA_FLAT_TIRE_SIMULATION',
  DAP_CUBE_ENDPOINT_V2 = 'DAP_CUBE_ENDPOINT_V2',
  COCKPIT_CAMERA_VIEW = 'COCKPIT_CAMERA_VIEW',
  SERVICE_BREAK_LOCATION_BOOKING_SLOTS = 'SERVICE_BREAK_LOCATION_BOOKING_SLOTS',
  TRIP_HISTORY = 'TRIP_HISTORY',
  VEHICLE_MONITORING = 'VEHICLE_MONITORING',
  EVALUATION_AI = 'EVALUATION_AI',
  HULK_TRIPS = 'HULK_TRIPS',
  TRIP_TRACING = 'TRIP_TRACING',
  MANUAL_SERVICE_INTERVAL_CREATION = 'MANUAL_SERVICE_INTERVAL_CREATION',
  STOP_NETWORK_STOPPING_ACCURACY = 'STOP_NETWORK_STOPPING_ACCURACY',
  DASHBOARD_AI_INSIGHTS = 'DASHBOARD_AI_INSIGHTS',
  ANNOTATION_TRIAGE = 'ANNOTATION_TRIAGE',
  GLOBAL_VEHICLE_MANAGEMENT = 'GLOBAL_VEHICLE_MANAGEMENT',
} // DONT DELETE - template injection feature

export type FeatureApp = 'backoffice' | 'admin-panel' | 'shared'

export const FEATURE_APP: Record<Features, FeatureApp> = {
  [Features.FEATURE_TOGGLE_TEST]: 'shared',
  [Features.ALWAYS_SHOW_ENVIRONMENT_INDICATOR]: 'shared',
  [Features.GRAPHQL_GDPR_SELF_ASSESSMENT]: 'backoffice',
  [Features.MUNICH_DEMO]: 'backoffice',
  [Features.DSBOSS_SCENARIOS_TABLE_PACE]: 'backoffice',
  [Features.STOP_NETWORK_IMPORTS]: 'backoffice',
  [Features.FLEET_TRACING_EXPERIMENTAL]: 'backoffice',
  [Features.STOP_NETWORK_TILE_FETCH]: 'backoffice',
  [Features.LAKE_NONA_FLAT_TIRE_SIMULATION]: 'backoffice',
  [Features.DAP_CUBE_ENDPOINT_V2]: 'backoffice',
  [Features.COCKPIT_CAMERA_VIEW]: 'backoffice',
  [Features.SERVICE_BREAK_LOCATION_BOOKING_SLOTS]: 'backoffice',
  [Features.TRIP_HISTORY]: 'admin-panel',
  [Features.VEHICLE_MONITORING]: 'admin-panel',
  [Features.EVALUATION_AI]: 'admin-panel',
  [Features.HULK_TRIPS]: 'admin-panel',
  [Features.TRIP_TRACING]: 'backoffice',
  [Features.MANUAL_SERVICE_INTERVAL_CREATION]: 'backoffice',
  [Features.STOP_NETWORK_STOPPING_ACCURACY]: 'backoffice',
  [Features.DASHBOARD_AI_INSIGHTS]: 'backoffice',
  [Features.ANNOTATION_TRIAGE]: 'admin-panel',
  [Features.GLOBAL_VEHICLE_MANAGEMENT]: 'admin-panel',
}
